<div class="pagina-sucesso">

  <main class="conteudo">

    <section class="sucesso-card">

      <div class="icone-sucesso">
        ✓
      </div>

      <h1>
        Reserva recebida!
      </h1>

      <p class="mensagem-principal">
        Sua reserva foi recebida com sucesso.
        Estamos processando as informações do pagamento
        e, em breve, você receberá a confirmação da sua hospedagem.
      </p>


      <div class="status-reserva">

        <div class="status-item">

          <span class="status-icone">
            ✓
          </span>

          <div>
            <strong>
              Reserva realizada
            </strong>

            <small>
              Sua solicitação foi recebida
            </small>
          </div>

        </div>


        <div class="status-item">

          <span class="status-icone">
            ✓
          </span>

          <div>
            <strong>
              Pagamento recebido
            </strong>

            <small>
              Pagamento em processamento
            </small>
          </div>

        </div>


        <div class="status-item pendente">

          <span class="status-icone">
            3
          </span>

          <div>
            <strong>
              Confirmação da hospedagem
            </strong>

            <small>
              Você receberá a confirmação em até 48H via whatsapp <strong>(11) 96334-0065</strong>
            </small>
          </div>

        </div>

      </div>

      <div class="aviso-email">

        <div class="email-icone">
          <svg xmlns="http://www.w3.org/2000/svg"
               width="24"
               height="24"
               viewBox="0 0 32 32"
               fill="currentColor">
            <path d="M16 .8A15.2 15.2 0 0 0 2.9 23.7L.8 31.2l7.7-2A15.2 15.2 0 1 0 16 .8zm0 27.6a12.3 12.3 0 0 1-6.3-1.7l-.5-.3-4.6 1.2 1.2-4.5-.3-.5A12.4 12.4 0 1 1 16 28.4zm6.8-9.3c-.4-.2-2.2-1.1-2.6-1.2-.3-.1-.6-.2-.8.2-.3.4-1 1.2-1.2 1.4-.2.2-.4.3-.8.1-.4-.2-1.6-.6-3-1.9-1.1-1-1.9-2.2-2.1-2.6-.2-.4 0-.6.2-.8l.6-.7.4-.6c.1-.2 0-.5 0-.7l-1.2-2.9c-.3-.7-.6-.6-.8-.6h-.7c-.3 0-.7.1-1 .5-.4.4-1.3 1.3-1.3 3.1s1.3 3.5 1.5 3.8c.2.2 2.6 4 6.3 5.5.9.4 1.6.6 2.1.8.9.3 1.7.2 2.3.1.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.7.2-1.8-.1-.2-.3-.3-.7-.5z"/>
          </svg>
        </div>

        <div>

          <strong>
            Fique de olho no seu whatsapp
          </strong>

          <p>
            Enviaremos a confirmação da reserva,
            os detalhes da hospedagem e as informações
            necessárias para o seu check-in.
          </p>

        </div>

      </div>

      <div class="acoes">

        <button
          type="button"
          class="btn-principal"
          (click)="voltarInicio()"
        >
          Voltar ao início
        </button>

      </div>


      <div class="mensagem-final">

        <span>
          Obrigado por escolher o Paraíso do Cerrado.
        </span>

      </div>

    </section>

  </main>

</div>
